import cx from 'classnames';

import {Button} from '#component/base';
import {sprinkles} from '#style/sprinkles';

import {RegistrationStepProps} from './RegistrationStep.types';

import * as css from './RegistrationStep.css';

export const RegistrationStep = ({
  className,
  children,
  isNextDisabled,
  isNextLoading,
  nextText = 'Continue',
  prevText = 'Back',
  onNext,
  onPrev,
  renderPrev,
}: RegistrationStepProps) => {
  let renderedPrevBtn: JSX.Element | null = null;
  if (renderPrev) {
    renderedPrevBtn = renderPrev(prevText, onPrev);
  } else if (onPrev) {
    renderedPrevBtn = (
      <Button
        variant="secondary-dark"
        className={sprinkles({order: [2, 1, 1]})}
        onClick={() => onPrev()}>
        {prevText}
      </Button>
    );
  }

  return (
    <div className={cx(css.root, className)}>
      <div>{children}</div>
      <div className={css.actions}>
        {renderedPrevBtn}
        <Button
          variant="primary-dark"
          className={css.primaryAction({single: !renderedPrevBtn})}
          onClick={() => onNext()}
          disabled={isNextDisabled}
          loading={isNextLoading}>
          {nextText}
        </Button>
      </div>
    </div>
  );
};
